var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFigmaLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 40,
    viewBox: "0 0 27 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20C13.5 18.3203 14.1585 16.7093 15.3306 15.5216C16.5027 14.3339 18.0924 13.6666 19.75 13.6666C21.4076 13.6666 22.9973 14.3339 24.1694 15.5216C25.3415 16.7093 26 18.3203 26 20C26 21.6797 25.3415 23.2906 24.1694 24.4783C22.9973 25.666 21.4076 26.3333 19.75 26.3333C18.0924 26.3333 16.5027 25.666 15.3306 24.4783C14.1585 23.2906 13.5 21.6797 13.5 20V20Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 32.6667C1 30.987 1.65848 29.3761 2.83058 28.1884C4.00268 27.0006 5.5924 26.3334 7.25 26.3334H13.5V32.6667C13.5 34.3464 12.8415 35.9573 11.6694 37.1451C10.4973 38.3328 8.9076 39 7.25 39C5.5924 39 4.00268 38.3328 2.83058 37.1451C1.65848 35.9573 1 34.3464 1 32.6667Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1V13.6667H19.75C21.4076 13.6667 22.9973 12.9994 24.1694 11.8117C25.3415 10.6239 26 9.01304 26 7.33333C26 5.65363 25.3415 4.04272 24.1694 2.85499C22.9973 1.66726 21.4076 1 19.75 1L13.5 1Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.33333C1 9.01304 1.65848 10.6239 2.83058 11.8117C4.00268 12.9994 5.5924 13.6667 7.25 13.6667H13.5V1H7.25C5.5924 1 4.00268 1.66726 2.83058 2.85499C1.65848 4.04272 1 5.65363 1 7.33333Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20C1 21.6797 1.65848 23.2906 2.83058 24.4783C4.00268 25.666 5.5924 26.3333 7.25 26.3333H13.5V13.6666H7.25C5.5924 13.6666 4.00268 14.3339 2.83058 15.5216C1.65848 16.7093 1 18.3203 1 20Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFigmaLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/figma_logo.fd017c27a094511a8d3ba65f5acbbaf5.svg";